export enum VIEWS {
  ROOT = 'root',
  ALERTS = 'alerts',
  LISTS = 'lists',
  LIST = 'list',
  USER = 'user',
}
